import React, { useState, useEffect } from 'react';
import './Promo.css';
import './Promo_mobile_enhanced.css';
import '../../components/Button/Button.css';
import '../../components/Disclaimer/Disclaimer.css';

const Promo = () => { 
  const [activeTab, setActiveTab] = useState('cloud-mining');
  const [timeLeft, setTimeLeft] = useState({
    days: 6,
    hours: 6,
    minutes: 15,
    seconds: 32
  });

  // Countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { days, hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              }
            }
          }
        }
        
        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (value) => {
    return value.toString().padStart(2, '0');
  };

  const asicsMarketplaceCards = [
    {
      type: 'basic',
      badges: ['Fresh from the Customer'],
      title: 'Antminer S21 188TH/s',
      subtitle: 'Operates in our data center, serviced by us',
      ecosScore: { value: '114.63', color: 'green' },
      ecosMetrics: {
        economicEfficiency: 211.33,
        operationTime: 20.2,
        energyEfficiency: 53.88
      },
      stockBadge: { text: 'Available now', type: 'light-green' },
      priceBadge: 'Promo Price',
      oldPrice: '$2,550',
      price: '$1,541',
      discount: { type: 'percentage', value: '40% savings:', amount: '$1,009' },
      specs: [
        { label: 'Basic power:', value: '6.00 TH/s' },
        { label: 'Total power:', value: '6.00 TH/s' }
      ],
      buttonClass: 'blue',
      buttonText: 'Buy from FX-Pool customer -40%',
      icons: [{ type: 'purple', text: null }]
    },
    {
      type: 'medium',
      badges: ['From FX-Pool Customer'],
      title: 'Antminer S21 200TH/s',
      subtitle: 'Operates in our data center, serviced by us',
      ecosScore: { value: '26.48', color: 'red' },
      ecosMetrics: {
        economicEfficiency: 5.97,
        operationTime: 78.09,
        energyEfficiency: 1.45
      },
      stockBadge: { text: 'Just posted', type: 'light-green' },
      priceBadge: 'Promo Price',
      oldPrice: '$2,650',
      price: '$1,500',
      discount: { type: 'percentage', value: '43% savings:', amount: '$1,150' },
      specs: [
        { label: 'Operating days:', value: '547' },
        { label: 'Uptime:', value: '99.7%' },
        { label: 'Efficiency W/TH:', value: '17.5 J/TH', hiddenMobile: true },
        { label: 'Hosting per month:', value: '$210' }
      ],
      buttonClass: 'light-blue',
      buttonText: 'Buy from FX-Pool customer -43%',
      icons: [{ type: 'green', text: null }]
    },
    {
      type: 'premium',
      badges: ['Best Deal'],
      title: 'Antminer S21 Pro 234TH/s',
      subtitle: 'Operates in our data center, serviced by us',
      ecosScore: { value: '62.75', color: 'yellow' },
      ecosMetrics: {
        economicEfficiency: 66.11,
        operationTime: 88.6,
        energyEfficiency: 25.7
      },
      stockBadge: { text: 'Best price on the market', type: 'light-green' },
      priceBadge: 'Promo Price',
      oldPrice: '$3,300',
      price: '$2,350',
      discount: { type: 'percentage', value: '29% savings:', amount: '$950' },
      specs: [
        { label: 'Operating days:', value: '75' },
        { label: 'Uptime:', value: '99.8%' },
        { label: 'Efficiency W/TH:', value: '15 J/TH', hiddenMobile: true },
        { label: 'Hosting per month:', value: '$205' }
      ],
      buttonClass: 'orange',
      buttonText: 'Buy from FX-Pool customer -29%',
      icons: [{ type: 'orange', text: 'HIT' }]
    }
  ];

  const asicPurchaseCards = [
    {
      type: 'basic',
      badges: ['1 ASIC', 'Newbies'],
      title: 'Antminer S21 Pro 234TH/s',
      subtitle: 'One miner with the maximum discount',
      priceBadge: 'Promo Price',
      oldPrice: '$3,800',
      price: '$3,300',
      discount: '$500',
      specs: [
        { label: 'Basic power:', value: '6.00 TH/s' },
        { label: 'Total power:', value: '6.00 TH/s' }
      ],
      buttonClass: 'blue',
      buttonText: 'Buy with a 13% discount',
      icons: [
        { type: 'green', text: null },
        { type: 'blue', text: 'X1' }
      ]
    },
    {
      type: 'medium',
      badges: ['5 ASICs', 'Experienced'],
      title: '5-ASIC Mining Farm',
      subtitle: 'Balance between price and return',
      priceBadge: 'Promo Price',
      oldPrice: '$19,650',
      price: '$17,150',
      discount: '$2,500',
      specs: [
        { label: 'Total power:', value: '1,225 TH/s' },
        { label: 'Personal engineer:', value: '24/7' },
        { label: 'Hosting per month:', value: '$1,015' }
      ],
      buttonClass: 'light-blue',
      buttonText: 'Get a mining farm with 13% off',
      icons: [
        { type: 'orange', text: null },
        { type: 'blue', text: 'X5' }
      ]
    },
    {
      type: 'premium',
      badges: ['10+ ASICs', 'Professionals'],
      title: '10-ASIC Mining Farm',
      subtitle: 'Maximum returns with VIP support',
      priceBadge: 'VIP Promo',
      oldPrice: '$51,500',
      price: '$46,500',
      discount: '$5,000',
      specs: [
        { label: 'Total power:', value: '2,700 TH/s' },
        { label: 'Personal engineer:', value: 'Dedicated manager' },
        { label: 'Hosting per month:', value: '$2,100' }
      ],
      buttonClass: 'orange',
      buttonText: 'Get a 10% VIP discount',
      icons: [
        { type: 'purple', text: null },
        { type: 'blue', text: 'X10+' }
      ]
    }
  ];

  const cloudMiningCards = [
    {
      type: 'basic',
      badge: 'short',
      title: 'Start package',
      subtitle: 'The service fee will be deducted from the mining reward',
      price: '$49',
      duration: '3 months',
      power: '96.49 TH/s',
      buttonClass: 'light-blue',
      icons: ['green', 'light-blue']
    },
    {
      type: 'basic',
      badge: 'medium',
      title: 'Start package',
      subtitle: 'The service fee will be deducted from the mining reward',
      price: '$149',
      duration: '6 months',
      power: '148.04 TH/s',
      buttonClass: 'light-blue',
      icons: ['green', 'light-blue']
    },
    {
      type: 'basic',
      badge: 'long',
      title: 'Start package',
      subtitle: 'The service fee will be deducted from the mining reward',
      price: '$199',
      duration: '12 months',
      power: '99.22 TH/s',
      buttonClass: 'light-blue',
      icons: ['green', 'light-blue']
    },
    {
      type: 'medium',
      badge: 'short',
      title: 'Prepaid',
      subtitle: 'One month paid',
      price: '$49',
      duration: '3 months',
      power: '119.00 TH/s',
      buttonClass: 'blue',
      icons: ['orange', 'light-blue']
    },
    {
      type: 'medium',
      badge: 'medium',
      title: 'Prepaid',
      subtitle: 'One month paid',
      price: '$149',
      duration: '6 months',
      power: '189.35 TH/s',
      buttonClass: 'blue',
      icons: ['orange', 'light-blue']
    },
    {
      type: 'medium',
      badge: 'long',
      title: 'Prepaid',
      subtitle: 'One month paid',
      price: '$199',
      duration: '12 months',
      power: '129.46 TH/s',
      buttonClass: 'blue',
      icons: ['orange', 'light-blue']
    },
    {
      type: 'premium',
      badge: 'short',
      title: 'Fully prepaid',
      subtitle: 'All service fees paid in advance',
      price: '$49',
      duration: '3 months',
      power: '14.88 TH/s',
      buttonClass: 'orange',
      icons: ['purple', 'light-blue']
    },
    {
      type: 'premium',
      badge: 'medium',
      title: 'Fully prepaid',
      subtitle: 'All service fees paid in advance',
      price: '$149',
      duration: '6 months',
      power: '23.26 TH/s',
      buttonClass: 'orange',
      icons: ['purple', 'light-blue']
    },
    {
      type: 'premium',
      badge: 'long',
      title: 'Fully prepaid',
      subtitle: 'All service fees paid in advance',
      price: '$199',
      duration: '12 months',
      power: '16.73 TH/s',
      buttonClass: 'orange',
      icons: ['purple', 'light-blue']
    }
  ];

  const renderIcon = (iconType) => {
    switch (iconType) {
      case 'green':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
            <path d="M5.59295 0L0.311851 6.41271C0.105026 6.66385 0.00161413 6.78943 3.37777e-05 6.89548C-0.00134007 6.98767 0.0392591 7.07538 0.110131 7.13334C0.191656 7.2 0.353191 7.2 0.676262 7.2H5L4.40705 12L9.68815 5.58729C9.89497 5.33615 9.99839 5.21058 9.99997 5.10452C10.0013 5.01233 9.96074 4.92462 9.88987 4.86666C9.80834 4.8 9.64681 4.8 9.32374 4.8H5L5.59295 0Z" fill="white"></path>
          </svg>
        );
      case 'light-blue':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M4.51797 12.9333C2.94396 12.9333 1.66797 11.6573 1.66797 10.0833C1.66797 8.59906 2.80259 7.3798 4.25181 7.24558C4.54825 5.44233 6.11412 4.06665 8.0013 4.06665C9.88848 4.06665 11.4544 5.44233 11.7508 7.24558C13.2 7.3798 14.3346 8.59906 14.3346 10.0833C14.3346 11.6573 13.0586 12.9333 11.4846 12.9333C8.70441 12.9333 6.95206 12.9333 4.51797 12.9333Z" fill="white"></path>
          </svg>
        );
      case 'orange':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M3.23016 9.10322C2.39683 9.80321 2.11905 11.881 2.11905 11.881C2.11905 11.881 4.19683 11.6032 4.89683 10.7699C5.29127 10.3032 5.28571 9.58654 4.84683 9.15321C4.63088 8.94711 4.34643 8.82802 4.04806 8.81879C3.74969 8.80956 3.45842 8.91085 3.23016 9.10322Z" fill="white"></path>
            <path d="M6.44444 9.22226L4.77778 7.55562C5.07341 6.78864 5.44567 6.05345 5.88889 5.3612C6.53621 4.32621 7.43757 3.47403 8.50722 2.88573C9.57688 2.29743 10.7793 1.99257 12 2.00014C12 3.51123 11.5667 6.16675 8.66667 8.11117C7.96494 8.55489 7.22047 8.92712 6.44444 9.22226Z" fill="white"></path>
            <path d="M4.77778 7.55562H2C2 7.55562 2.30556 5.87231 3.11111 5.33343C4.01111 4.73343 5.88889 5.3612 5.88889 5.3612" fill="white"></path>
            <path d="M6.44444 9.22226V12C6.44444 12 8.12778 11.6944 8.66667 10.8889C9.26667 9.98892 8.66667 8.11117 8.66667 8.11117" fill="white"></path>
          </svg>
        );
      case 'purple':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
            <path d="M11.0007 1L6.67297 5.72118C6.45516 5.95879 6.34626 6.07759 6.22068 6.12211C6.11021 6.16126 5.99122 6.16126 5.88076 6.12211C5.75518 6.07759 5.64627 5.95879 5.42847 5.72118L3.92297 4.07882C3.70516 3.84121 3.59626 3.72241 3.47068 3.67789C3.36021 3.63874 3.24122 3.63874 3.13076 3.67789C3.12654 3.67939 3.12443 3.68014 3.05345 3.71912C2.92439 3.79 2.85217 3.85021 2.75923 3.96442C2.70812 4.02722 2.59473 4.22455 2.36797 4.61921L1 7M11.0007 1H7.15072M11.0007 1V5.2" stroke="white" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        );
      case 'blue':
        return null; // Blue icon is just text, no SVG
      default:
        return null;
    }
  };

  return (
    <div className="landing-container">
      <header className="promo-header">
        <div className="promo-header__content">
          <div className="promo-header__info">
            <h1 className="promo-header__title">Limited Offers</h1>
            <p className="promo-header__subtitle">Hurry up and buy at the old prices before the increase</p>
          </div>
          <nav className="promo-header__nav">
            <ul className="promo-header__list">
              <li className="promo-header__item">• Buy ASICs</li>
              <li className="promo-header__item">• Cloud Mining</li>
              <li className="promo-header__item">• ASICs Marketplace</li>
            </ul>
          </nav>
        </div>
        <div className="promo-header__timer-banner">
          <div className="promo-timer">
            <div className="promo-timer__label">THE PROMOTION ENDS IN:</div>
            <div className="promo-timer__countdown">
              <div className="promo-timer__unit">
                <span className="promo-timer__value">{formatTime(timeLeft.days)}</span>
                <span className="promo-timer__label-small">DAYS</span>
              </div>
              <div className="promo-timer__unit">
                <span className="promo-timer__value">{formatTime(timeLeft.hours)}</span>
                <span className="promo-timer__label-small">HOURS</span>
              </div>
              <div className="promo-timer__unit">
                <span className="promo-timer__value">{formatTime(timeLeft.minutes)}</span>
                <span className="promo-timer__label-small">MINUTES</span>
              </div>
              <div className="promo-timer__unit">
                <span className="promo-timer__value">{formatTime(timeLeft.seconds)}</span>
                <span className="promo-timer__label-small">SECONDS</span>
              </div>
            </div>
          </div>
          <section className="promo-banner">
            <div className="promo-banner__container">
              <div className="promo-banner__content">
                <h2 className="promo-banner__title">Hurry up and buy limited offers<br></br></h2>
              </div>
            </div>
          </section>
        </div>
      </header>

      <section className="promo-cards">
        <div className="promo-cards__container">
          <div className="promo-tabs">
            <button 
              className={`promo-tabs__button ${activeTab === 'cloud-mining' ? 'promo-tabs__button--active' : ''}`}
              onClick={() => setActiveTab('cloud-mining')}
            >
              Cloud Mining
            </button>
            <button 
              className={`promo-tabs__button ${activeTab === 'asic-purchase' ? 'promo-tabs__button--active' : ''}`}
              onClick={() => setActiveTab('asic-purchase')}
            >
              ASIC Purchase
            </button>
            <button 
              className={`promo-tabs__button ${activeTab === 'asics-marketplace' ? 'promo-tabs__button--active' : ''}`}
              onClick={() => setActiveTab('asics-marketplace')}
            >
              ASICs Marketplace
            </button>
          </div>

          <div className={`promo-cards__grid promo-cards__grid--${activeTab}`}>
            {activeTab === 'asics-marketplace' ? (
              asicsMarketplaceCards.map((card, index) => (
                <article 
                  key={index} 
                  className={`promo-card promo-card--${card.type} promo-card--asic-purchase promo-card--clickable`}
                  onClick={() => {
                    console.log('Marketplace card clicked:', card.title);
                    // Add navigation logic here
                  }}
                >
                  <div className="promo-card__header">
                    <div className="promo-card__badges">
                      <div className="promo-card__badges-item">
                        {card.badges.map((badge, badgeIndex) => (
                          <span key={badgeIndex} className="promo-card__badge">{badge}</span>
                        ))}
                      </div>
                    </div>
                    <div className="promo-card__header-right">
                      <p className="promo-card__ecos-score-header">
                        <span className={`promo-card__ecos-score-header-value ecos-score--${card.ecosScore.color}`}>
                          {card.ecosScore.value}
                        </span>
                        {' '}FX-Pool Score
                      </p>
                      <div className="promo-card__arrow">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <h3 className="promo-card__title">{card.title}</h3>
                  <p className="promo-card__subtitle">{card.subtitle}</p>
                  <div className="promo-card__image">
                    <div className="promo-card__img-wrapper">
                      <img src="/images/order/asic.webp" alt="promo-card image" className="promo-card__img" />
                      <div className="promo-card__icons">
                        {card.icons.map((icon, iconIndex) => (
                          <div key={iconIndex} className={`promo-card__icon promo-card__icon--${icon.type}`}>
                            {icon.text ? (
                              <span className="promo-card__icon-text">{icon.text}</span>
                            ) : (
                              <span className="promo-card__icon-svg">
                                {renderIcon(icon.type)}
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className={`promo-card__stock-badge promo-card__stock-badge--${card.stockBadge.type}`}>
                      {card.stockBadge.text}
                    </div>
                  </div>
                  <div className="ecos-score promo-card__ecos-score">
                    <div className="ecos-score__metrics">
                      <div className="ecos-score__metric">
                        <div className="ecos-score__metric-block">
                          <span className="ecos-score__metric-label">Economic efficiency</span>
                          <span className="ecos-score__metric-value">{card.ecosMetrics.economicEfficiency}</span>
                        </div>
                        <div className="ecos-score__progress-bar">
                          <div 
                            className="ecos-score__progress-fill ecos-score__progress-fill--efficiency" 
                            style={{ width: `${card.ecosMetrics.economicEfficiency}%` }}
                          ></div>
                        </div>
                      </div>
                      <div className="ecos-score__metric">
                        <div className="ecos-score__metric-block">
                          <span className="ecos-score__metric-label">Operation Time</span>
                          <span className="ecos-score__metric-value">{card.ecosMetrics.operationTime}</span>
                        </div>
                        <div className="ecos-score__progress-bar">
                          <div 
                            className="ecos-score__progress-fill ecos-score__progress-fill--operation" 
                            style={{ width: `${card.ecosMetrics.operationTime}%` }}
                          ></div>
                        </div>
                      </div>
                      <div className="ecos-score__metric">
                        <div className="ecos-score__metric-block">
                          <span className="ecos-score__metric-label">Energy efficiency</span>
                          <span className="ecos-score__metric-value">{card.ecosMetrics.energyEfficiency}</span>
                        </div>
                        <div className="ecos-score__progress-bar">
                          <div 
                            className="ecos-score__progress-fill ecos-score__progress-fill--energy" 
                            style={{ width: `${card.ecosMetrics.energyEfficiency}%` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div className="ecos-score__main">
                      <div className="ecos-score__title">FX-Pool Score</div>
                      <div className="ecos-score__value">{card.ecosScore.value}</div>
                      <div className="ecos-score__status">Advised</div>
                    </div>
                  </div>
                  <div className="promo-card__pricing promo-card__pricing--discount">
                    <div className="promo-card__price-badge">{card.priceBadge}</div>
                    <div className="promo-card__price-wrapper">
                      <div className="promo-card__price-main">
                        <span className="promo-card__price-label-text">Price:</span>
                        <span className="promo-card__old-price">{card.oldPrice}</span>
                        <span className="promo-card__price-value">{card.price}</span>
                      </div>
                    </div>
                    <div className="promo-card__discount">
                      <span>{card.discount.value}</span>
                      <p className="promo-card__discount-value">{card.discount.amount}</p>
                    </div>
                  </div>
                  <div className="promo-card__specs">
                    {card.specs.map((spec, specIndex) => (
                      <div 
                        key={specIndex} 
                        className={`promo-card__spec ${spec.hiddenMobile ? 'promo-card__spec--hidden-mobile' : ''}`} 
                        data-spec-label={spec.label}
                      >
                        <span className="promo-card__spec-label">{spec.label}</span>
                        <span className="promo-card__spec-value">{spec.value}</span>
                      </div>
                    ))}
                  </div>
                  <button className={`promo-card__button promo-card__button--${card.buttonClass}`}>
                    {card.buttonText}
                  </button>
                </article>
              ))
            ) : activeTab === 'asic-purchase' ? (
              asicPurchaseCards.map((card, index) => (
                <article 
                  key={index} 
                  className={`promo-card promo-card--${card.type} promo-card--asic-purchase promo-card--clickable`}
                  onClick={() => {
                    window.history.pushState({ page: 'buy-asics' }, '', '/order/buy-asics/90/1');
                    window.location.reload();
                  }}
                >
                  <div className="promo-card__header">
                    <div className="promo-card__badges">
                      <div className="promo-card__badges-item">
                        {card.badges.map((badge, badgeIndex) => (
                          <span key={badgeIndex} className="promo-card__badge">{badge}</span>
                        ))}
                      </div>
                    </div>
                    <div className="promo-card__header-right">
                      <div className="promo-card__arrow">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <h3 className="promo-card__title">{card.title}</h3>
                  <p className="promo-card__subtitle">{card.subtitle}</p>
                  <div className="promo-card__image">
                    <div className="promo-card__img-wrapper">
                      <img src="/images/order/asic.webp" alt="promo-card image" className="promo-card__img" />
                      <div className="promo-card__icons">
                        {card.icons.map((icon, iconIndex) => (
                          <div key={iconIndex} className={`promo-card__icon promo-card__icon--${icon.type}`}>
                            {icon.text ? (
                              <span className="promo-card__icon-text">{icon.text}</span>
                            ) : (
                              <span className="promo-card__icon-svg">
                                {renderIcon(icon.type)}
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="promo-card__pricing promo-card__pricing--discount">
                    <div className="promo-card__price-badge">{card.priceBadge}</div>
                    <div className="promo-card__price-wrapper">
                      <div className="promo-card__price-main">
                        <span className="promo-card__price-label-text">Price:</span>
                        <span className="promo-card__old-price">{card.oldPrice}</span>
                        <span className="promo-card__price-value">{card.price}</span>
                      </div>
                    </div>
                    <div className="promo-card__discount">
                      <span>You save:</span>
                      <p className="promo-card__discount-value">{card.discount}</p>
                    </div>
                  </div>
                  <div className="promo-card__specs">
                    {card.specs.map((spec, specIndex) => (
                      <div key={specIndex} className="promo-card__spec" data-spec-label={spec.label}>
                        <span className="promo-card__spec-label">{spec.label}</span>
                        <span className="promo-card__spec-value">{spec.value}</span>
                      </div>
                    ))}
                  </div>
                  <button className={`promo-card__button promo-card__button--${card.buttonClass}`}>
                    {card.buttonText}
                  </button>
                </article>
              ))
            ) : (
              cloudMiningCards.map((card, index) => (
                <article 
                  key={index} 
                  className={`promo-card promo-card--${card.type} promo-card--clickable`}
                  onClick={() => {
                    const cardData = {
                      type: card.type,
                      title: card.title,
                      subtitle: card.subtitle,
                      price: card.price.replace('$', ''),
                      duration: card.duration,
                      power: card.power,
                      badge: card.badge
                    };
                    const encodedData = encodeURIComponent(JSON.stringify(cardData));
                    window.history.pushState({ page: 'tariff-details' }, '', `/order/tariff/${encodedData}`);
                    window.location.reload();
                  }}
                >
                  <div className="promo-card__header">
                    <div className="promo-card__badges">
                      <div className="promo-card__badges-item">
                        <span className="promo-card__badge">{card.badge}</span>
                      </div>
                    </div>
                    <div className="promo-card__header-right">
                      <div className="promo-card__arrow">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <h3 className="promo-card__title">{card.title}</h3>
                  <p className="promo-card__subtitle">{card.subtitle}</p>
                  <div className="promo-card__image">
                    <div className="promo-card__img-wrapper">
                      <img src="/images/order/asic.webp" alt="promo-card image" className="promo-card__img" />
                      <div className="promo-card__icons">
                        {card.icons.map((iconType, iconIndex) => (
                          <div key={iconIndex} className={`promo-card__icon promo-card__icon--${iconType}`}>
                            <span className="promo-card__icon-svg">
                              {renderIcon(iconType)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="promo-card__pricing">
                    <div className="promo-card__price">
                      <span className="promo-card__price-value">{card.price}</span>
                    </div>
                    <div className="promo-card__price-label">Contract price</div>
                  </div>
                  <div className="promo-card__specs">
                    <div className="promo-card__spec" data-spec-label="Duration">
                      <span className="promo-card__spec-label">Duration:</span>
                      <span className="promo-card__spec-value">{card.duration}</span>
                    </div>
                    <div className="promo-card__spec" data-spec-label="Total power">
                      <span className="promo-card__spec-label">Total power:</span>
                      <span className="promo-card__spec-value">{card.power}</span>
                    </div>
                  </div>
                  <button 
                    className={`promo-card__button promo-card__button--${card.buttonClass}`}
                  >
                    Get access
                  </button>
                </article>
              ))
            )}
          </div>
        </div>
      </section>

      <section className="promo__disclaimer">
        <div className="promo__container">
          <p className="promo__disclaimer-title">Disclaimer</p>
          <p className="promo__disclaimer-text">
            All estimates are based on current Bitcoin network conditions, the current BTC exchange rate, and the current mining difficulty. Actual results may vary significantly depending on cryptocurrency price volatility, changes in network difficulty, and other market factors. For cloud mining, daily service fees must be taken into account. For ASIC miners, the monthly hosting cost ($195/device) must be taken into account. This information is not a guarantee of profitability or an investment recommendation.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Promo;

